import * as Sentry from "@sentry/browser";
import Cookies from "js-cookie";
import { v4 as uuidv4 } from "uuid";

export function initBrowserUserId() {
  const oldCookie = Cookies.get("browser_user_id");
  if (oldCookie) {
    Sentry.setExtra("browser_user_id", oldCookie);
    return;
  }

  const newCookie = uuidv4(); // IEサポートが終わったが、一部テナントで古いブラウザが引き続き利用されるため uuidv4 は残す
  Cookies.set("browser_user_id", newCookie);
  Sentry.setExtra("browser_user_id", newCookie);
}
